import { Injectable, Provider } from "@angular/core";
import { CustomTextClient, CustomTextGetQuery, CustomTextGetQueryResult } from "../../INTEGRA_Shop_Client";
import { firstValueFrom } from "rxjs";
import { ICustomTextApiService, ICustomTextApiServiceToken } from "./custom-text-api-service.interface";

@Injectable({
  providedIn: 'root'
})
export class CustomTextApiService implements ICustomTextApiService {

  constructor(
    private customTextClient: CustomTextClient,
  ) { }

  public async swagCustomTextGet(query: CustomTextGetQuery): Promise<CustomTextGetQueryResult> {
    return firstValueFrom(this.customTextClient.customTextGet(query));
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const CustomTextApiServiceProvider: Provider[] = [
  { provide: CustomTextClient },
  { provide: ICustomTextApiServiceToken, useExisting: CustomTextApiService }
];
